import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {TableLimitUtils} from 'notebook/performance/tableLimitUtils';
import TableUtil from 'notebook/tables/TableUtil';
import {Note} from 'notebook/util/NoteUtilConstants';
import {GRAY_DARK, ORANGE, RED} from 'ui-library/Colors';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

interface NotebookPerformanceMonitorToggleProps {
  note: Note;
  openModal: () => void;
}

export function NotebookPerformanceMonitorToggle({
  note,
  openModal,
}: NotebookPerformanceMonitorToggleProps): JSX.Element {
  const tables = TableUtil.getTablesFromNote(note);

  const {numCells} = TableLimitUtils.analyzeNotePerformance(tables);
  let icon: BenchlingIconName = 'gauge-min';
  let iconColor = styles.defaultColor;
  if (TableLimitUtils.sizeIsOverMaximum(numCells)) {
    icon = 'gauge-max';
    iconColor = styles.errorColor;
  } else if (TableLimitUtils.sizeIsInWarningRange(numCells)) {
    icon = 'gauge';
    iconColor = styles.warningColor;
  }

  return (
    <BufferOptionsItem>
      <BenchlingIcon icon={icon} className={css(iconColor, styles.icon)} onClick={openModal} />
    </BufferOptionsItem>
  );
}

const styles = StyleSheet.create({
  warningColor: {
    color: ORANGE,
  },
  errorColor: {
    color: RED,
  },
  defaultColor: {
    color: GRAY_DARK,
  },
  icon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
    height: '16px',
    width: '16px',
    ':hover': {
      cursor: 'pointer',
    },
    marginBottom: '3px',
  },
});
